// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/InventoryReservation.yaml
// Generated: 2026-01-22T15:19:14.249Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateInventoryReservation, UpdateInventoryReservation, InventoryReservation } from '@/types/inventory/InventoryReservation';

/**
 * InventoryReservation Service
 * CRUD operations for InventoryReservation via the ABP API.
 */
export const inventoryReservationService = new EntityService<InventoryReservation, CreateInventoryReservation, UpdateInventoryReservation>(
  '/api/inventory/inventoryreservation',
  'InventoryReservation',
);
